/**
 * LLM Bot Configuration — Data Model
 * Generic bot config factory, no app-specific constants.
 */

export function createBotConfig(overrides = {}, defaultToolCategories = []) {
  return {
    botId: overrides.botId || `bot-${Date.now()}`,
    displayName: overrides.displayName || 'New Bot',
    description: overrides.description || '',
    llm: {
      mode: 'remote',
      provider: null,
      model: null,
      apiKey: null,
      workerPublicKey: null,
      ...overrides.llm,
    },
    role: {
      systemPrompt: null,
      ...overrides.role,
    },
    toolCategories: overrides.toolCategories || [...defaultToolCategories],
    isBuiltIn: false,
  }
}
